var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listing"},[_c('ListingInfo',_vm._b({},'ListingInfo',{ ProductInfo: _vm.ProductInfo },false)),_c('ListingRelated',_vm._b({},'ListingRelated',{ ProductInfo: _vm.ProductInfo },false)),_c('div',{staticStyle:{"text-align":"center","margin-bottom":"60px"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v("\n    |\n    "),_c('router-link',{attrs:{"to":"/profile"}},[_vm._v("Profile")])],1),(_vm.userAddress !== null && _vm.userAddress == _vm.ProductInfo.seller)?_c('SellerNav',_vm._b({},'SellerNav',{
      status: _vm.ProductInfo.status.toNumber(),
      contractAddr: _vm.contractAddr,
      instance: _vm.instance
    },false)):(_vm.ProductInfo.seller !== null)?_c('BuyerNav',_vm._b({},'BuyerNav',{
      status: _vm.ProductInfo.status.toNumber(),
      contractAddr: _vm.contractAddr,
      instance: _vm.instance,
      sellerInfo: _vm.ProductInfo.contact,
      isBuyer: _vm.userAddress === _vm.ProductInfo.buyerAddress
    },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }